"use client";

import { Grid2, Typography } from "@repo/ui";
import Section from "../components/Section";
import FastFillingSchedule from "@/components/courses/FastFillingSchedule";
// import CourseDesignation from "@/components/courses/CourseDesignation";

type AboutCourseProps = {
  data: {
    heading?: string;
    description?: string;
    designation?: string;
    event?: ServiceEvent;
  };
  sectionInfo: PageSections;
};

const AboutCourse = ({ data, sectionInfo }: AboutCourseProps) => {
  return (
    <Section
      id={sectionInfo.sectionId}
      className={sectionInfo.sectionClass}
      data-title={sectionInfo.name}
    >
      <Grid2 container spacing={5}>
        <Grid2 size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
          <Typography variant="h2" className="!mb-5">
            {data.heading}
          </Typography>
          <Typography className="[&_p]:mb-4 last:[&_p]:mb-0">
            {data.description}
          </Typography>

          {/* <CourseDesignation /> */}
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          {/* Fast filling schedule card here  */}
          <FastFillingSchedule data={data?.event} />
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default AboutCourse;
